import { ReactNode, RefObject, useLayoutEffect, useRef } from 'react'

/** Move focus before hiding an exiting action from assistive technology. */
export const CollapsingAction = ({
	entered,
	focusFallback,
	children
}: {
	entered: boolean
	focusFallback: RefObject<HTMLDivElement>
	children: ReactNode
}) => {
	const ref = useRef<HTMLDivElement>(null)
	useLayoutEffect(() => {
		const node = ref.current
		if (!node) return
		if (!entered && node.contains(document.activeElement)) {
			focusFallback.current?.focus({ preventScroll: true })
		}
		// Apply these together after focus moves; JSX aria-hidden would run before this effect.
		node.setAttribute('aria-hidden', String(!entered))
		if (entered) node.removeAttribute('inert')
		else node.setAttribute('inert', '')
	}, [entered, focusFallback])
	return (
		<div ref={ref} className={`form-spam-collapse-x ${entered ? 'form-spam-collapse-x--open' : ''}`}>
			{children}
		</div>
	)
}
